// 问题处理
export default [
  //售前问题
  // {
  //     path: '/pre-saleProblem',
  //     name: 'pre-saleProblem',
  //     component: () => import( /* webpackChunkName: "problemSolving" */ '@/views/home/problemSolving/pre-saleProblem'),
  //     meta: {
  //         activeMenu: 'pre-saleProblem', // 可用选中菜单
  //         // keepAlive: true // true 开启。
  //     }
  // },
  //不良汇总
  {
    path: '/menu3_problem_bad',
    name: 'menu3_problem_bad',
    component: () => import( /* webpackChunkName: "problemSolving" */ '@/views/home/problemSolving/problem_bad'),
    meta: {
      activeMenu: 'menu3_problem_bad', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //海外仓异常物品登记
  {
    path: '/overseasWarehouseAbnormalItems',
    name: 'overseasWarehouseAbnormalItems',
    component: () => import( /* webpackChunkName: "problemSolving" */ '@/views/home/problemSolving/overseasWarehouseAbnormalItems'),
    meta: {
      activeMenu: 'overseasWarehouseAbnormalItems', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
]